// @flow

import React from "react"
import styled from "styled-components"

type Props = {
  children: Object,
  white?: boolean
}

const StyledParagraph = styled.p`
  color: #${p => (p.white ? "fff" : "272623")};
  display: inline-block;
  font-size: 15px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 600;
  letter-spacing: normal;
  line-height: normal;
  padding-bottom: 0px;
  margin: 0px;
`

const ParagraphPrimary = (props: Props): React$Element<any> => {
  return <StyledParagraph {...props}>{props.children}</StyledParagraph>
}

export default ParagraphPrimary
